import { AdvancedPlatformsActions } from './advanced-platforms.action';
import {
  IPendingSubscription,
  IPlatform,
} from '../../models/advanced-platforms/iplatform-model';
import { getCurrentFormattedLocaleStringDate } from '../../../shared/helpers/utils/date';

export interface IPlatformsState {
  list: IPlatform[];
  pendingList: boolean;
  listError: Error;

  isGetSubscriptionsCompleted: boolean;
  getSubscriptionsError: Error;

  pendingSubscribe: boolean;
  subscribeError: Error;

  pendingUnsubscribe: boolean;
  unSubscribeError: Error;

  isBuyPlatform: boolean;
  isSetSubscribeError: boolean;

  pendingSubscriptionList: IPendingSubscription[];
}

export const initialState: IPlatformsState = {
  list: [],
  pendingList: false,
  listError: null,

  isGetSubscriptionsCompleted: false,
  getSubscriptionsError: null,

  pendingSubscribe: false,
  subscribeError: null,

  pendingUnsubscribe: false,
  unSubscribeError: null,

  isBuyPlatform: false,
  isSetSubscribeError: false,

  pendingSubscriptionList: [],
};

export function SettingErrorMessage(
  platform: IPlatform,
  action: AdvancedPlatformsActions
) {
  if (platform.id === action.payload.platformId) {
    platform.lastTradesReceivedDatetime = ' Erro ao carregar...';
  }
}

export function AdvancedPlatformsReducer(
  state: IPlatformsState,
  action: AdvancedPlatformsActions
) {
  state = { ...(state || initialState) };
  switch (action.type) {
    // Platforms
    case AdvancedPlatformsActions.getPlatforms:
      return { ...state, pendingList: true, listError: null };

    case AdvancedPlatformsActions.getPlatformsSuccess:
      return {
        ...state,
        list: action.payload,
        pendingList: false,
        listError: null,
        isGetSubscriptionsCompleted: false,
      };

    case AdvancedPlatformsActions.getPlatformsError:
      return { ...state, pendingList: false, listError: action.payload };

    // Subscribe GET
    case AdvancedPlatformsActions.getSubscribes:
      return {
        ...state,
        isGetSubscriptionsCompleted: false,
        getSubscriptionsError: null,
      };

    case AdvancedPlatformsActions.getSubscribesSuccess: {
      const listClone = [...state.list];

      action.payload.forEach((pay) => {
        listClone.forEach((platform, i) => {
          if (pay.platformId === platform.id) {
            listClone[i] = {
              ...listClone[i],
              subscriptionStatus: pay.status,
              subscribeDate: pay.subscribeDate,
            };
          }
        });
      });

      return {
        ...state,
        list: listClone,
        isGetSubscriptionsCompleted: true,
        getSubscriptionsError: null,
      };
    }

    case AdvancedPlatformsActions.getSubscribesError:
      return {
        ...state,
        isGetSubscriptionsCompleted: true,
        getSubscriptionsError: action.payload,
      };

    // Subscribe GET
    // case AdvancedPlatformsActions.getClientsTradedOperationsCount:
    //   return { ...state, pendingSubscribe: true, subscribeError: null }

    case AdvancedPlatformsActions.getClientsTradedOperationsCountSuccess: {
      const listClone = [...state.list];

      listClone.forEach((platform) => {
        if (platform.id === action.payload.platformId) {
          platform.trades = action.payload.trades;
          platform.lastTradesReceivedDatetime =
            getCurrentFormattedLocaleStringDate();
        }
      });

      return { ...state, listClone };
    }

    case AdvancedPlatformsActions.getClientsTradedOperationsCountError:
      const list = [...state.list];

      list.forEach((platform) => SettingErrorMessage(platform, action));

      return { ...state, list };

    // Subscribe SET
    case AdvancedPlatformsActions.setSubscribe:
      return { ...state, pendingSubscribe: true, subscribeError: null };

    case AdvancedPlatformsActions.setSubscribeSuccess: {
      const listClone = [...state.list];

      const platformIndex = listClone.findIndex(
        (index) => index.id === action.payload.platformId
      );
      if (platformIndex >= 0) {
        listClone[platformIndex] = {
          ...listClone[platformIndex],
          isSuccess: true,
          subscriptionStatus: action.payload.status,
          activationUrl: action.payload.activationUrl || '',
          hasError: false,
          errorMessage: '',
        };
      }

      return {
        ...state,
        list: listClone,
        pendingSubscribe: false,
        subscribeError: null,
        isBuyPlatform: true,
      };
    }

    case AdvancedPlatformsActions.setSubscribeError: {
      const listClone = [...state.list];

      const platformIndex = listClone.findIndex(
        (index) => index.id === action.payload.platformId
      );
      if (platformIndex >= 0) {
        listClone[platformIndex] = {
          ...listClone[platformIndex],
          hasError: true,
          errorMessage: action.payload.error.error.error.message,
        };
      }

      return {
        ...state,
        list: listClone,
        pendingSubscribe: false,
        isSetSubscribeError: true,
        subscribeError: action.payload.error,
      };
    }

    // Unsubscribe
    case AdvancedPlatformsActions.setUnsubscribe:
      return { ...state, pendingUnsubscribe: true, unSubscribeError: null };

    // Revisar: validar retorno do back-end (em processo de implementação)
    case AdvancedPlatformsActions.setUnsubscribeSuccess:
      return {
        ...state,
        list: action.payload,
        pendingUnsubscribe: false,
        unSubscribeError: null,
      };

    case AdvancedPlatformsActions.setUnsubscribeError:
      return {
        ...state,
        pendingUnsubscribe: false,
        unSubscribeError: action.payload,
      };

    // Resets
    case AdvancedPlatformsActions.resetBuyPlatform:
      return { ...state, isBuyPlatform: false, isSetSubscribeError: false };

    case AdvancedPlatformsActions.resetSetSubscribeError:
      return { ...state, isSetSubscribeError: false };

    default:
      return state;
  }
}
